import taxAccountStatementApi from "@/api/taxAccountStatementApi";

const taxAccountStatementStore = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    pageQuery({ commit }, data) {
      return taxAccountStatementApi.pageQuery(data).then((res) => {
        //commit("setDeclareList", res.result);
        return res;
      });
    },
    submitTaxExpenseBuildExcelTask({ commit }, data) {
      return taxAccountStatementApi
        .submitTaxExpenseBuildExcelTask(data)
        .then((res) => {
          //commit("setDeclareList", res.result);
          return res;
        });
    },
  },
};

export default taxAccountStatementStore;
